export default {
	root: {
		path: '/',
		displayName: 'Home'
	},
	routes: [
		{
			path: 'dashboard',
			displayName: 'menu.dashboard'
		},
    {
      path: 'processes',
      displayName: 'menu.processes',
      disabled: true,
      children: [
        {
          path: 'processes-list',
          displayName: 'processes.list',
        },
        {
          path: 'request-reimbursement',
          displayName: 'menu.requestReimbursement',
        },
        {
          path: 'processes-draft',
          displayName: 'menu.draft',
        },
      ]
    },
    {
      path: 'request-reimbursement',
      displayName: 'menu.requestReimbursement',
      disabled: true,
      children: [
        {
          path: 'request-reimbursement-list',
          displayName: 'request-reimbursement.list',
        },
      ]
    },
		{
			path: 'leads',
			displayName: 'leads.title',
			disabled: true,
			children: [
				{
					path: 'leads-list',
					displayName: 'leads.list',
				},
				{
					path: 'new-lead',
					displayName: 'leads.new'
				},
			]
		},
		{
			path: 'team',
			displayName: 'team.title',
			disabled: true,
			children: [
				{
					path: 'team-list',
					displayName: 'team.teamList',
				},
				{
					path: 'team-new',
					displayName: 'team.teamNew'
				},
				{
					path: 'team-edit',
					displayName: 'team.teamEdit'
				},
			]
		},
		{
			path: 'reports',
			displayName: 'reports.title',
			disabled: true,
			children: [
				{
					path: 'reports-list',
					displayName: 'reports.reportsList',
				},
				{
					path: 'reports-new',
					displayName: 'reports.reportsNew'
				},
				{
					path: 'reports-detail',
					displayName: 'reports.reportsDetail'
				}
			]
		},
	]
}



// WEBPACK FOOTER //
// ./src/components/admin/app-breadcrumbs/Breadcrumbs.js